module.exports = __webpack_public_path__ + "static/media/GQ.d2974f94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GQ.svg
// module id = 264
// module chunks = 0